
<template>
  <ActicsLandingPageLayout>
    <div class="hvh-flex space-between mx-2 mt-5">
      <div class="col-12 col-md-3 col-lg-4 pt-0">
        <div class="main-title mb-3">
          <span class="nexa-black">SP</span>
          <span class="nexa-regular">CORE</span>
        </div>
        <div class="mb-4">
          <p>
            Drive Risk Predictions and Inform the Next Best Action: Leverage out-of-the-box integration with ACTICS for data enrichment and predictive insights. Identify at-risk patients most in need of access assistance, powered by Eversana's
            sophisticated AI/ML platform.
          </p>
          <p>
            High Quality and Fully Scalable SP Data: Link Specialty Pharmacy, HUB EMR, and Claims data to achieve longitudinal insights on the patient journey. Utilize the cloud-based platform for fast and efficient data source onboarding. ACTICS'
            end-to-end specialty data management solution provides automated validation and SME support so you can trust your data.
          </p>
          <p>
            Always Up to Date, Always Transparent: Analyses are constantly updated with the latest real-world data feeds, so your insights keep in step with the real-world trends. A custom documentation output facilitates easy review and
            modification.
          </p>
          <p>Let us demonstrate how SPCore can help you unlock insight into your specialty therapies to improve medication adherence and patient outcomes</p>
        </div>
        <div class="pt-2">
          <v-btn class="hvh-btn hvh-btn--secondary m-0" flat small outline @click="sendRequest">Request A Demo</v-btn>
        </div>
      </div>
      <div class="col-md-8 col-lg-7" v-if="$store.getters.windowSize('md')">
        <img class="image" :src="$loadImage(image)" />
      </div>
    </div>
    <Loader v-if="isSending" />
  </ActicsLandingPageLayout>
</template>

<script>

import axios from '../../axios';
import image from '../../assets/images/actics/spcore-request-demo.png';
import ActicsLandingPageLayout from '../../components/actics/landingPage/ActicsLandingPageLayout.vue';
import { errorDebug } from '../../libraries/common';
export default {
  title: 'Request Demo',
  components: { ActicsLandingPageLayout, },
  data() {
    return {
      isSending: false,
      image,
    };
  },
  methods: {
    sendRequest() {
      this.isSending = true;
      axios.post('/SPCore/RequestDemo/RequestDemoMail')
        .then(() => this.$alert('Thank you', 'A member of the ACTICS team will reach out to you shortly.'))
        .then(() => this.$router.back())
        .catch(errorDebug)
        .then(() => this.isSending = false);
    }
  }
}
</script>

<style lang="scss" scoped>
.main-title {
  font-size: 36px;
}

.image {
  width: 100%;
  height: 100%;
  max-height: 600px;
  object-fit: contain;
}

p {
  font-size: 12px;
}
</style>